<div class="device-layer2map">
  <div class="device-layer2map-map-container"></div>
</div>
